export const ActionItems = {
    EDIT: "EDIT",
    DELETE: "DELETE",
    USERS: "USERS"
};